export const indexMenuLinks = [
  {
    name: 'How It Works',
    link: '/#features',
  },
  {
    name: 'Join Our Beta',
    link: '/join',
  },
];
